import React from 'react';
import { Link } from 'react-router-dom';
import './News.css'


const NewsAndMediya = () => {
    return (
        <div>




            <div className=" w-full">
                <div className=" w-full">
                    <img src="https://www.manipalhospitalsglobal.com/assets/images/best-speciality-hospital-in-india.jpg" className="w-full" alt='' />
                </div>
            </div>


            <div className='text-center my-10'>
                <button style={{ backgroundColor: '#00b7ac', color: 'white', boxShadow: "0 2px 12px #949494" }} className='px-6 py-2.5 rounded ' >
                    <Link to={'#'}>Digital Media</Link>
                </button>
                <button style={{ border: '1px solid #00b7ac', boxShadow: "0 2px 12px #949494", color: '#0c51a1' }} className='px-6 py-2.5 rounded ml-5' >
                    <Link to={'#'}>Digital Media</Link>
                </button>
            </div>

































            <div className='mx-28 mb-10  mar '>
                <div className='h-[21rem] pbot hei rounded'  style={{ background: "linear-gradient(180deg,#034ea1 0,#00b7ac 100%),#c4c4c4" }}>
                    <div className='rounded-xl  mb m-1 fl hei h-[20.8rem]  ' style={{ borderTop: '5px solid #034ea1', display: 'flex ', backgroundColor: 'white' }}>
                        <div className='w-[42%] wi bb rounded-xl truncate mb-' >
                            <img className='h-full w-full' src="https://dhen.mv/wp-content/uploads/2022/05/photo_2022-05-06-15.09.19-850x548.jpeg" alt="" />

                        </div>
                        <div className='w-[59%] h-[95%] m-2 wi ' >
                            <div className='text-lg font-bold' style={{ color: '#034ea1' }}>
                                Launch of Master Medics Program Press Conference and Special webinar addressing importance advanced training in nursing
                            </div>
                            <div className='snap-y h-[30%] mt-5 mrr sc' style={{ overflowY: 'scroll', scrollbarColor: 'yellow;' }}>
                                Manipal Hospitals in collaboration with the Ghana Registered Nurses and Midwives
                                Association GRNMA launched a Master Medics Programme to commemorate the International Nurses Day 2022 in Tema The program was
                                held via a zoom webinar on May 11 2022 from 3 00 PM to 5 00 PM IST The objective of the webinar was to share medical knowledge with 1000 Ghanian nurses The key topics covered under the Master Medics Program were ACLS and BLS overview hand hygiene practices infection control needlestick
                                injury barrier nursing safe infusion practices prevention of pressure sores nursing initial assessment and documentation The webinar was

                            </div>
                            <div className=''>
                                <div>

                                    <span className='font-black'>Location: </span>Delhi,Goa,Gurugram,Hebbal - Bengaluru,Old Airport Road <br />
                                    - Bengaluru,Yeshwanthpur - Bengaluru
                                </div>
                                <div>
                                    <span className='font-black'>Publication: </span>Delhi,Goa,Gurugram,Hebbal - Bengaluru,Old Airport Road <br />
                                    - Bengaluru,Yeshwanthpur - Bengaluru
                                </div>
                                <div>
                                    <span className='font-black'>Date: </span>11/12/20025
                                </div>

                                <div>
                                    <span className='font-black'>Link: </span>www.www./www./wwww./sks./
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>










            <div className='mx-28 mb-10   mar '>
                <div className='h-[21rem]  pbot hei rounded' style={{ background: "linear-gradient(180deg,#034ea1 0,#00b7ac 100%),#c4c4c4" }}>
                    <div className='rounded-xl m-1 fl hei h-[20.8rem]  ' style={{ borderTop: '5px solid #034ea1', display: 'flex ', backgroundColor: 'white' }}>
                        <div className='w-[42%] wi bb rounded-xl truncate mb-' >
                            <img className=' w-full' src="https://www.manipalhospitalsglobal.com/assets/frontend-assets/images/PressReleases/ghana-news-article-manipal-hospital-international.png" alt="" />

                        </div>
                        <div className='w-[59%] h-[95%] m-2 wi ' >
                            <div className='text-lg font-bold' style={{ color: '#034ea1' }}>
                                Launch of Master Medics Program Press Conference and Special webinar addressing importance advanced training in nursing
                            </div>
                            <div className='snap-y h-[30%] mt-5 mrr sc' style={{ overflowY: 'scroll', scrollbarColor: 'yellow;' }}>
                                Manipal Hospitals in collaboration with the Ghana Registered Nurses and Midwives
                                Association GRNMA launched a Master Medics Programme to commemorate the International Nurses Day 2022 in Tema The program was
                                held via a zoom webinar on May 11 2022 from 3 00 PM to 5 00 PM IST The objective of the webinar was to share medical knowledge with 1000 Ghanian nurses The key topics covered under the Master Medics Program were ACLS and BLS overview hand hygiene practices infection control needlestick
                                injury barrier nursing safe infusion practices prevention of pressure sores nursing initial assessment and documentation The webinar was

                            </div>
                            <div>
                                <div>

                                    <span className='font-black'>Location: </span>Delhi,Goa,Gurugram,Hebbal - Bengaluru,Old Airport Road <br />
                                    - Bengaluru,Yeshwanthpur - Bengaluru
                                </div>
                                <div>
                                    <span className='font-black'>Publication: </span>Delhi,Goa,Gurugram,Hebbal - Bengaluru,Old Airport Road <br />
                                    - Bengaluru,Yeshwanthpur - Bengaluru
                                </div>
                                <div>
                                    <span className='font-black'>Date: </span>11/12/20025
                                </div>

                                <div>
                                    <span className='font-black'>Link: </span>www.www./www./wwww./sks./
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>




















            <div className='mx-28 mb-10  mar '>
                <div className='h-[21rem] pbot hei pbot rounded' style={{ background: "linear-gradient(180deg,#034ea1 0,#00b7ac 100%),#c4c4c4" }}>
                    <div className='rounded-xl m-1 fl hei h-[20.8rem]  ' style={{ borderTop: '5px solid #034ea1', display: 'flex ', backgroundColor: 'white' }}>
                        <div className='w-[42%] wi bb  rounded-xl truncate mb-' >
                            <img className='h-full w-full' src="https://www.manipalhospitalsglobal.com/assets/frontend-assets/images/PressReleases/AFC-Health-Limited-joins-hand-with-Manipal-Hospital--Group-2111251347w.webp" alt="" />

                        </div>
                        <div className='w-[59%] h-[95%] m-2 wi ' >
                            <div className='text-lg font-bold' style={{ color: '#034ea1' }}>
                                Launch of Master Medics Program Press Conference and Special webinar addressing importance advanced training in nursing
                            </div>
                            <div className='snap-y h-[30%] mt-5 mrr sc' style={{ overflowY: 'scroll', scrollbarColor: 'yellow;' }}>
                                Manipal Hospitals in collaboration with the Ghana Registered Nurses and Midwives
                                Association GRNMA launched a Master Medics Programme to commemorate the International Nurses Day 2022 in Tema The program was
                                held via a zoom webinar on May 11 2022 from 3 00 PM to 5 00 PM IST The objective of the webinar was to share medical knowledge with 1000 Ghanian nurses The key topics covered under the Master Medics Program were ACLS and BLS overview hand hygiene practices infection control needlestick
                                injury barrier nursing safe infusion practices prevention of pressure sores nursing initial assessment and documentation The webinar was

                            </div>
                            <div>
                                <div>

                                    <span className='font-black'>Location: </span>Delhi,Goa,Gurugram,Hebbal - Bengaluru,Old Airport Road <br />
                                    - Bengaluru,Yeshwanthpur - Bengaluru
                                </div>
                                <div>
                                    <span className='font-black'>Publication: </span>Delhi,Goa,Gurugram,Hebbal - Bengaluru,Old Airport Road <br />
                                    - Bengaluru,Yeshwanthpur - Bengaluru
                                </div>
                                <div>
                                    <span className='font-black'>Date: </span>11/12/20025
                                </div>

                                <div>
                                    <span className='font-black'>Link: </span>www.www./www./wwww./sks./
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

















            <div className='mx-28 mb-10 mar '>
                <div className='h-[21rem] pbot hei rounded' style={{ background: "linear-gradient(180deg,#034ea1 0,#00b7ac 100%),#c4c4c4" }}>
                    <div className='rounded-xl m-1 fl hei h-[20.8rem]  ' style={{ borderTop: '5px solid #034ea1', display: 'flex ', backgroundColor: 'white' }}>
                        <div className='w-[42%] wi bb  rounded-xl truncate mb-' >
                            <img className='h-full w-full' src="https://www.manipalhospitalsglobal.com/assets/frontend-assets/images/PressReleases/news-ghana-com.png" alt="" />

                        </div>
                        <div className='w-[59%] h-[95%] m-2 wi ' >
                            <div className='text-lg font-bold' style={{ color: '#034ea1' }}>
                                Launch of Master Medics Program Press Conference and Special webinar addressing importance advanced training in nursing
                            </div>
                            <div className='snap-y h-[30%] mt-5 mrr sc' style={{ overflowY: 'scroll', scrollbarColor: 'yellow;' }}>
                                Manipal Hospitals in collaboration with the Ghana Registered Nurses and Midwives
                                Association GRNMA launched a Master Medics Programme to commemorate the International Nurses Day 2022 in Tema The program was
                                held via a zoom webinar on May 11 2022 from 3 00 PM to 5 00 PM IST The objective of the webinar was to share medical knowledge with 1000 Ghanian nurses The key topics covered under the Master Medics Program were ACLS and BLS overview hand hygiene practices infection control needlestick
                                injury barrier nursing safe infusion practices prevention of pressure sores nursing initial assessment and documentation The webinar was

                            </div>
                            <div>
                                <div>

                                    <span className='font-black'>Location: </span>Delhi,Goa,Gurugram,Hebbal - Bengaluru,Old Airport Road <br />
                                    - Bengaluru,Yeshwanthpur - Bengaluru
                                </div>
                                <div>
                                    <span className='font-black'>Publication: </span>Delhi,Goa,Gurugram,Hebbal - Bengaluru,Old Airport Road <br />
                                    - Bengaluru,Yeshwanthpur - Bengaluru
                                </div>
                                <div>
                                    <span className='font-black'>Date: </span>11/12/20025
                                </div>

                                <div>
                                    <span className='font-black'>Link: </span>www.www./www./wwww./sks./
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>



















            <div className='mx-28 mb-10  mar '>
                <div className='h-[21rem ] pbot hei rounded' style={{ background: "linear-gradient(180deg,#034ea1 0,#00b7ac 100%),#c4c4c4" }}>
                    <div className='rounded-xl m-1 fl hei h-[20.8rem]  ' style={{ borderTop: '5px solid #034ea1', display: 'flex ', backgroundColor: 'white' }}>
                        <div className='w-[42%] wi bb   rounded-xl truncate mb-' >
                            <img className='h-full w-full' src="https://dhen.mv/wp-content/uploads/2022/05/photo_2022-05-06-15.09.19-850x548.jpeg" alt="" />

                        </div>
                        <div className='w-[59%] h-[95%] m-2 wi ' >
                            <div className='text-lg font-bold' style={{ color: '#034ea1' }}>
                                Launch of Master Medics Program Press Conference and Special webinar addressing importance advanced training in nursing
                            </div>
                            <div className='snap-y h-[30%] mt-5 mrr sc' style={{ overflowY: 'scroll', scrollbarColor: 'yellow;' }}>
                                Manipal Hospitals in collaboration with the Ghana Registered Nurses and Midwives
                                Association GRNMA launched a Master Medics Programme to commemorate the International Nurses Day 2022 in Tema The program was
                                held via a zoom webinar on May 11 2022 from 3 00 PM to 5 00 PM IST The objective of the webinar was to share medical knowledge with 1000 Ghanian nurses The key topics covered under the Master Medics Program were ACLS and BLS overview hand hygiene practices infection control needlestick
                                injury barrier nursing safe infusion practices prevention of pressure sores nursing initial assessment and documentation The webinar was

                            </div>
                            <div>
                                <div>

                                    <span className='font-black'>Location: </span>Delhi,Goa,Gurugram,Hebbal - Bengaluru,Old Airport Road <br />
                                    - Bengaluru,Yeshwanthpur - Bengaluru
                                </div>
                                <div>
                                    <span className='font-black'>Publication: </span>Delhi,Goa,Gurugram,Hebbal - Bengaluru,Old Airport Road <br />
                                    - Bengaluru,Yeshwanthpur - Bengaluru
                                </div>
                                <div>
                                    <span className='font-black'>Date: </span>11/12/20025
                                </div>

                                <div>
                                    <span className='font-black'>Link: </span>www.www./www./wwww./sks./
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

























            <div className='mx-28 mb-10  mar '>
                <div className='h-[21rem] pbot hei rounded' style={{ background: "linear-gradient(180deg,#034ea1 0,#00b7ac 100%),#c4c4c4" }}>
                    <div className='rounded-xl m-1 fl hei h-[20.8rem]  ' style={{ borderTop: '5px solid #034ea1', display: 'flex ', backgroundColor: 'white' }}>
                        <div className='w-[42%] wi bb rounded-xl truncate mb-' >
                            <img className='h-full w-full' src="https://dhen.mv/wp-content/uploads/2022/05/photo_2022-05-06-15.09.19-850x548.jpeg" alt="" />

                        </div>
                        <div className='w-[59%] h-[95%] m-2 wi ' >
                            <div className='text-lg font-bold' style={{ color: '#034ea1' }}>
                                Launch of Master Medics Program Press Conference and Special webinar addressing importance advanced training in nursing
                            </div>
                            <div className='snap-y h-[30%] mt-5 mrr sc' style={{ overflowY: 'scroll', scrollbarColor: 'yellow;' }}>
                                Manipal Hospitals in collaboration with the Ghana Registered Nurses and Midwives
                                Association GRNMA launched a Master Medics Programme to commemorate the International Nurses Day 2022 in Tema The program was
                                held via a zoom webinar on May 11 2022 from 3 00 PM to 5 00 PM IST The objective of the webinar was to share medical knowledge with 1000 Ghanian nurses The key topics covered under the Master Medics Program were ACLS and BLS overview hand hygiene practices infection control needlestick
                                injury barrier nursing safe infusion practices prevention of pressure sores nursing initial assessment and documentation The webinar was

                            </div>
                            <div>
                                <div>

                                    <span className='font-black'>Location: </span>Delhi,Goa,Gurugram,Hebbal - Bengaluru,Old Airport Road <br />
                                    - Bengaluru,Yeshwanthpur - Bengaluru
                                </div>
                                <div>
                                    <span className='font-black'>Publication: </span>Delhi,Goa,Gurugram,Hebbal - Bengaluru,Old Airport Road <br />
                                    - Bengaluru,Yeshwanthpur - Bengaluru
                                </div>
                                <div>
                                    <span className='font-black'>Date: </span>11/12/20025
                                </div>

                                <div>
                                    <span className='font-black'>Link: </span>www.www./www./wwww./sks./
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>







        </div>
    );
};

export default NewsAndMediya;